import axios from 'axios'

import * as types from '../types'

const state = {
  registerStatus: null,
  registerBusy: false,
  registerData: { 'companyDetails': {}, 'personalDetails': {}, 'loginDetails': {} }
}

const getters = {
  registerStatus: (state) => {
    return state.registerStatus
  },
  registerBusy: (state) => {
    return state.registerBusy
  },
  registerData: (state) => {
    return state.registerData
  }
}

const mutations = {
  [types.MUTATE_REGISTER_STATUS]: (state, status) => {
    state.registerStatus = status
  },
  [types.MUTATE_REGISTER_BUSY]: (state, status) => {
    state.registerBusy = status
  },
  [types.MUTATE_REGISTER_DATA]: (state, data) => {
    state.registerData[data.key] = data.formData
  }
}

const actions = {
  [types.SAVE_REGISTRATION_DATA]: ({ commit, dispatch }, registerData) => {
    commit(types.MUTATE_REGISTER_DATA, registerData)
  },
  [types.REGISTER]: ({ commit, state, dispatch }, authData) => {
    commit(types.MUTATE_REGISTER_BUSY, true)

    axios
      .post('/customer/register', state.registerData)
      .then(res => {
        const now = new Date()
        const expirationDate = new Date(
          now.getTime() + res.data.expires_at * 1000
        )
        localStorage.setItem('token', res.data.access_token)
        localStorage.setItem('user', JSON.stringify(res.data.user))
        localStorage.setItem('expirationDate', expirationDate)

        // Store the details in vuex
        commit(types.MUTATE_LOGGED_IN_USER, {
          token: res.data.access_token,
          user: res.data.user
        })
        // TODO, fix timer & what kind of logic does the customer want?
        // dispatch('setLogoutTimer', res.data.expires_at)
      })
      .catch(error => {
        // We need to let the user know his registration failed
        commit(types.MUTATE_REGISTER_STATUS, {
          'message': error.response ? error.response.data.message : error.message,
          'success': false
        })
      })
      .finally(() => {
        commit(types.MUTATE_REGISTER_BUSY, false)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
